/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextareaAutosize,
  Typography,
} from '@mui/material';
import {
  getListTaskCollection,
  postListTaskCollection,
} from '@Store/feature/listTaskSlice';
import { getPricingType } from '@Store/feature/pricingSlice';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Icons } from '../../../assets/SvgIcons';
import { TaskViewType } from '../../../config/enum';
import { Section } from '../../../config/section';
import { TaskType } from '../../../config/task';
import { ComponentHelper } from '../../../helper/Infra';
import { ICTask, TaskResponse } from '../../../helper/Interfaces';
import { getAssetsPlaybooks } from '../../../store/feature/assetsSlice';
import {
  getPlayBookDetail,
  postDealTaskList,
  postListChanges,
  postSectionList,
} from '../../../store/feature/playBookDetailSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import TrialEndModal from '../TrialEndModal/TrialEndModal';
import classes from './NewTask.module.css';
import {
  getPersonalTemplatesDetail,
  postProjectTemplateDetailSections,
  postProjectTemplateDetailTask,
} from '@Store/feature/personalTemplatesDetailSlice';

type NewTaskProps = {
  taskType: TaskType;
  setnewTaskVisible: (newTaskVisible: boolean) => void;
  task?: ICTask;
  taskViewType: TaskViewType;
  setInitialTaskVisible?: (newTaskVisible: boolean) => void;
  initialTaskVisible?: boolean;
  section?: Section;
  createSubTask?: (task: ICTask) => void;
  createRiskTask?: (task: ICTask) => void;
  createIssueTask?: (task: ICTask) => void;
  createDecisionTask?: (task: ICTask) => void;
  createDependencyTask?: (task: ICTask) => void;
  createdRidTaskType?: string;
  setCreatedRidTaskType?: (type: string) => void;
  filterRidTaskType?: string;
};

export const NewTask: FC<NewTaskProps> = ({
  taskType,
  setnewTaskVisible,
  task,
  taskViewType,
  setInitialTaskVisible,
  initialTaskVisible,
  section,
  createSubTask,
  createRiskTask,
  createIssueTask,
  createDecisionTask,
  createDependencyTask,
  createdRidTaskType,
  setCreatedRidTaskType,
  filterRidTaskType,
}) => {
  const inputReference = useRef<HTMLTextAreaElement>(null);
  const [title, setTitle] = useState<string>('');
  const [, setdate] = useState<Date | undefined>(undefined);
  const { sectionList, dealTaskList, hasChanges } =
    useAppSelector(getPlayBookDetail);
  const playBooks = useAppSelector(getAssetsPlaybooks);
  const currentVersion = useAppSelector(getListTaskCollection);
  const [hadRidTypeError, setHadRidTypeError] = useState(false);
  let { pid, id } = useParams();

  const dispatch = useAppDispatch();
  const componentHelper = new ComponentHelper();
  const location = useLocation();

  const { playbook, tasks, sections } = useAppSelector(
    getPersonalTemplatesDetail
  );

  const [, setCanBeMultiple] = useState(false);
  const [useMultiple, setuseMultiple] = useState(false);
  const [multipleElement, setmultipleElement] = useState<string[]>([]);

  const pricingReducer = useAppSelector(getPricingType);
  const isTrialEnd = componentHelper.isDealspaceTrialEnd(pricingReducer);

  useEffect(() => {
    inputReference.current?.focus();
  }, []);

  const createMultipleTask = async () => {
    const createdTasks = [] as ICTask[];
    const createSections = [];
    console.log('multiple', multipleElement);
    setuseMultiple(false);
    let template = false;
    if (location.pathname.split('/')[1] === 'personal-templates-detail') {
      template = true;
    }
    for (const item of multipleElement) {
      if (item === '') {
        return;
      }
      const playbookId = pid as string;
      let dealspaceId = '' as string;
      if (playBooks) {
        dealspaceId =
          playBooks.find(playbook => playbook.id === pid)?.dealspaceId || '';
      }

      if (taskType === TaskType.Section) {
        const result = await componentHelper.createSection({
          projectId: playbookId,
          sectionName: item,
        });
        createSections.push(result);
      }

      if (taskType === TaskType.Task) {
        if (section) {
          const result = await componentHelper.createTask({
            name: item,
            playbookId: template ? playbook?.id : playbookId,
            sectionId: section.id,
            dealspaceId: template ? playbook?.project.workspaceId : dealspaceId,
          });
          const responseCreate = result.data as TaskResponse;
          createdTasks.push(...responseCreate.taskDto);
        } else if (createSubTask) {
          const res = await componentHelper.createSubTask({
            name: item ?? ' ',
            parentId: task?.id ?? '',
          });
          const responseCreate = res.data as TaskResponse;
          createdTasks.push(...responseCreate.taskDto);
        } else if (createRiskTask) {
          const res = await componentHelper.createRisk({
            name: item ?? ' ',
            parentId: task?.id ?? '',
            workspaceId: id ?? '',
          });
          const responseCreate = res.data as TaskResponse;
          createdTasks.push(...responseCreate.taskDto);
        } else if (createIssueTask) {
          const res = await componentHelper.createIssue({
            name: item ?? ' ',
            parentId: task?.id ?? '',
          });
          const responseCreate = res.data as TaskResponse;
          createdTasks.push(...responseCreate.taskDto);
        } else if (createDecisionTask) {
          const res = await componentHelper.createDecision({
            name: item ?? ' ',
            parentId: task?.id ?? '',
          });
          const responseCreate = res.data as TaskResponse;
          createdTasks.push(...responseCreate.taskDto);
        } else if (createDependencyTask) {
          const newTask = {
            name: item,
          } as ICTask;
          createDependencyTask(newTask);
        } else if (createdRidTaskType && createdRidTaskType === 'all') {
          toast('Please select risk , issue , decision');
        }
      }
    }

    if (taskType === TaskType.Section) {
      dispatch(postSectionList([...(sectionList ?? []), ...createSections]));
    } else {
      if (template) {
        dispatch(postProjectTemplateDetailTask([...tasks, ...createdTasks]));
      } else {
        dispatch(postDealTaskList([...dealTaskList, ...createdTasks]));
      }
    }
  };

  const createTask = (event: any) => {
    let success = true;
    if (title.trim() === '') {
      return;
    }
    const playbookId = pid as string;
    let dealspaceId = '' as string;
    let template = false;
    if (location.pathname.split('/')[1] === 'personal-templates-detail') {
      template = true;
    }

    if (playBooks) {
      dealspaceId =
        playBooks.find(playbook => playbook.id === pid)?.dealspaceId ||
        (id ?? '');
    }

    if (taskType === TaskType.Section) {
      componentHelper
        .createSection({
          projectId: template ? playbook?.id! : playbookId,
          sectionName: title,
        })
        .then(value => {
          if (template) {
            dispatch(postProjectTemplateDetailSections([...sections, value]));
          } else {
            dispatch(postSectionList([...(sectionList ?? []), value]));
          }

          setnewTaskVisible(false);
          setTimeout(() => {
            const violation = document.getElementById(value.id);
            if (violation) {
              window.scrollTo({
                top: violation.offsetTop,
                behavior: 'smooth',
              });
            }
          }, 500);
        });
    }
    if (taskType === TaskType.Task) {
      if (section) {
        componentHelper
          .createTask({
            name: title,
            playbookId: template ? playbook?.id : playbookId,
            sectionId: section.id,
            dealspaceId: template ? playbook?.project.workspaceId : dealspaceId,
          })
          .then(value => {
            const responseValue = value.data as TaskResponse;
            const createdTaskResponse = responseValue.taskDto;
            const currentListVersion = { ...currentVersion };

            dispatch(postListTaskCollection(currentListVersion));
            if (template) {
              dispatch(
                postProjectTemplateDetailTask([
                  ...tasks,
                  ...createdTaskResponse,
                ])
              );
            } else {
              dispatch(
                postDealTaskList([...dealTaskList, ...createdTaskResponse])
              );
              if (currentListVersion[section.id]) {
                currentListVersion[section.id] = [
                  ...currentListVersion[section.id],
                  ...createdTaskResponse,
                ];
              } else {
                currentListVersion[section.id] = [...createdTaskResponse];
              }
            }
          });
      } else if (createSubTask) {
        const newTask = {
          name: title,
        } as ICTask;
        createSubTask(newTask);
      } else if (createRiskTask) {
        const newTask = {
          name: title,
        } as ICTask;
        createRiskTask(newTask);
      } else if (createIssueTask) {
        const newTask = {
          name: title,
        } as ICTask;
        createIssueTask(newTask);
      } else if (createDecisionTask) {
        const newTask = {
          name: title,
        } as ICTask;
        createDecisionTask(newTask);
      } else if (createDependencyTask) {
        const newTask = {
          name: title,
        } as ICTask;
        createDependencyTask(newTask);
      } else {
        console.log('tasktype', taskType);
        event.preventDefault();
        event.stopPropagation();
        setHadRidTypeError(true);
        success = false;
        toast('Please select a task type');
      }
    }
    if (success) {
      endNewTask(
        setnewTaskVisible,
        setInitialTaskVisible,
        setTitle,
        setdate,
        event
      );
    }
    return null;
  };

  const handleRidTypeChange = (
    event: SelectChangeEvent<typeof createdRidTaskType>
  ) => {
    setHadRidTypeError(false);
    const {
      target: { value },
    } = event;
    if (value === '[RISK]') {
      setCreatedRidTaskType!('risk');
      return;
    }
    if (value === '[ISSU]') {
      setCreatedRidTaskType!('issue');
      return;
    }
    if (value === '[DEC]') {
      setCreatedRidTaskType!('decision');
      return;
    }
  };

  const getPlaceHolder = () => {
    if (taskType === TaskType.Section) {
      return 'Add New Section Title';
    } else {
      if (createSubTask) return 'Add New SubTask Title';
      else if (createIssueTask) return 'Add New Issue Title';
      else if (createRiskTask) return 'Add New Risk Title';
      else if (createDecisionTask) return 'Add New Decision Title';
      else if (createDependencyTask) return 'Add New Dependency Title';
      else return 'Add New Task Title';
    }
  };

  useEffect(() => {
    if (setCreatedRidTaskType) {
      if (filterRidTaskType) setCreatedRidTaskType(filterRidTaskType);
      else if (createdRidTaskType) setCreatedRidTaskType(createdRidTaskType);
      else setCreatedRidTaskType('all');
    }
  }, [filterRidTaskType]);

  useEffect(() => {
    if (
      task?.type &&
      ['risk', 'issue', 'decision'].includes(task.type) &&
      setCreatedRidTaskType
    ) {
      setCreatedRidTaskType('decision');
    }
  }, [task]);

  return (
    <React.Fragment>
      {isTrialEnd ? (
        <TrialEndModal
          showModal={true}
          setShowModal={() => setnewTaskVisible(false)}
        />
      ) : (
        <div
          className={[
            classes.container,
            taskViewType === TaskViewType.BOARD && classes.containerBoard,
          ].join(' ')}
        >
          <div
            className={[
              classes.contentLeft,
              taskViewType === TaskViewType.BOARD && classes.contentLeftBoard,
            ].join(' ')}
            style={{ width: '100%' }}
          >
            {createdRidTaskType && (
              <Select
                labelId="ridType-task"
                id="ridType-task"
                className={'ridTypeSelect'}
                displayEmpty
                renderValue={value =>
                  createdRidTaskType === 'risk' ? (
                    '[RISK]'
                  ) : createdRidTaskType === 'issue' ? (
                    '[ISSU]'
                  ) : createdRidTaskType === 'decision' ? (
                    '[DEC]'
                  ) : (
                    <em>Select</em>
                  )
                }
                value={
                  createdRidTaskType === 'risk'
                    ? '[RISK]'
                    : createdRidTaskType === 'issue'
                    ? '[ISSU]'
                    : createdRidTaskType === 'decision'
                    ? '[DEC]'
                    : ''
                }
                onChange={handleRidTypeChange}
              >
                {!['risk', 'issue', 'decision'].includes(task?.type ?? '') && (
                  <MenuItem value={'[RISK]'}>
                    <Icons.Risks20 /> <span className="ridMenuName">Risk</span>
                  </MenuItem>
                )}
                {!['risk', 'issue', 'decision'].includes(task?.type ?? '') && (
                  <MenuItem value={'[ISSU]'}>
                    <Icons.Issues20 />{' '}
                    <span className="ridMenuName">Issue</span>
                  </MenuItem>
                )}
                <MenuItem value={'[DEC]'}>
                  <Icons.Decision20 />{' '}
                  <span className="ridMenuName">Decision</span>
                </MenuItem>
              </Select>
            )}
            <TextareaAutosize
              maxRows={1}
              placeholder={getPlaceHolder()}
              className={[
                classes.input,
                taskViewType === TaskViewType.BOARD && classes.inputBoard,
              ].join(' ')}
              style={{ resize: 'none' }}
              ref={inputReference}
              draggable={'false'}
              value={title}
              onChange={e => {
                setTitle(e.target.value);
                if (
                  e.target.value.includes('\n') &&
                  e.target.value.split('\n').filter(i => i !== '').length > 1
                ) {
                  setCanBeMultiple(true);
                  setuseMultiple(true);
                  setmultipleElement(
                    e.target.value.split('\n').filter(i => i !== '')
                  );
                } else {
                  setuseMultiple(false);
                }
              }}
              onKeyDown={event => {
                if (event.key === 'Enter' && title === '') {
                  return;
                }
                if (
                  event.key === 'Enter' ||
                  (event.key === 'Escape' && !useMultiple && title !== '')
                ) {
                  console.log('title', title);
                  createTask(event);
                }
                if (event.key === 'Escape' && title === '') {
                  setnewTaskVisible(false);
                }
              }}
              onBlur={evt => {
                if (
                  title.length &&
                  !useMultiple &&
                  !hadRidTypeError &&
                  title !== ''
                ) {
                  createTask(evt);
                  //setnewTaskVisible(false);
                  setInitialTaskVisible && setInitialTaskVisible(false);
                  setTitle('');
                  setdate(undefined);
                } else {
                }
              }}
            />
            {multipleElement.length > 0 && (
              <Card sx={{ maxWidth: 345 }}>
                <CardMedia component="text" height="140" />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    Looks like you’re trying to paste a lot of{' '}
                    {taskType === TaskType.Section ? 'sections' : 'tasks'} over.
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Let us help you split that!
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    onClick={() => {
                      setuseMultiple(true);
                      createMultipleTask();
                      setnewTaskVisible(false);
                      setTitle('');
                      setdate(undefined);
                      setmultipleElement([]);
                      setuseMultiple(false);
                    }}
                  >
                    Create {multipleElement.length}{' '}
                    {taskType === TaskType.Section ? 'sections' : 'tasks'}
                  </Button>
                  <Button
                    size="small"
                    onClick={evt => {
                      createTask(evt);
                      setnewTaskVisible(false);
                      setTitle('');
                      setdate(undefined);
                      setmultipleElement([]);
                      setuseMultiple(false);
                    }}
                  >
                    Create a single{' '}
                    {taskType === TaskType.Section ? 'section' : 'task'}
                  </Button>
                </CardActions>
              </Card>
            )}
          </div>
          <div
            className={[
              classes.contentRight,
              taskViewType === TaskViewType.BOARD && classes.contentRightBoard,
            ].join(' ')}
          >
            <IconButton
              aria-label="delete"
              size="large"
              onClick={() => {
                setTitle('');
                setdate(undefined);
                setnewTaskVisible(false);
              }}
            >
              <Icons.Vector />
            </IconButton>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default NewTask;
function endNewTask(
  setnewTaskVisible: (newTaskVisible: boolean) => void,
  setInitialTaskVisible: ((newTaskVisible: boolean) => void) | undefined,
  setTitle: React.Dispatch<React.SetStateAction<string>>,
  setdate: React.Dispatch<React.SetStateAction<Date | undefined>>,
  event: any
) {
  //setnewTaskVisible(false);
  setInitialTaskVisible && setInitialTaskVisible(false);
  setTitle('');
  setdate(undefined);
  event.preventDefault();
  event.stopPropagation();
}
